/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Connections_DescriptionInputs */



/**
* | output |
* | --- |
* | "One endpoint and key each, serving any number of models. oneAI charges nothing for their use." |
*
* @param {Private_Models_Connections_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connections_description = /** @type {((inputs?: Private_Models_Connections_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connections_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Je ein Endpunkt und ein Schlüssel, für beliebig viele Modelle. oneAI berechnet für ihre Nutzung nichts.")
	return /** @type {LocalizedString} */ ("One endpoint and key each, serving any number of models. oneAI charges nothing for their use.")
});